import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 16px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
